// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_PWV4n","specs":"specs_L0PxD","g-label":"g-label","g-value":"g-value"};